import React from 'react';

import * as styled from './Switch.styled';

interface ISwitch {
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
  style?: React.CSSProperties;
}

export const Switch: React.FC<ISwitch> = ({ state, setState, style }) => (
  <styled.Label style={style}>
    <styled.Input
      type="checkbox"
      checked={state}
      onChange={() => setState(!state)}
    />
    <styled.SwitchBox />
  </styled.Label>
);
